import * as React from 'react';
const SvgCodeInterview = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={6} fill="#4C81DD" />
    <mask
      id="mask0_3701_1464"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={5}
      width={16}
      height={14}
    >
      <path
        d="M4 6.79201C4 5.96777 4.6303 5.33746 5.45455 5.33746H18.5455C19.3697 5.33746 20 5.96777 20 6.79201V15.2284C20 16.0526 19.3697 16.6829 18.5455 16.6829H8.50909L5.45455 18.5253C4.82424 18.9132 4 18.4284 4 17.7011V6.79201Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3701_1464)">
      <path
        d="M5.45464 4.3678C4.09706 4.3678 3.0304 5.43446 3.0304 6.79204H4.96979C4.96979 6.50113 5.16373 6.30719 5.45464 6.30719V4.3678ZM18.5455 6.30719C18.8365 6.30719 19.0304 6.50113 19.0304 6.79204H20.9698C20.9698 5.43446 19.9031 4.3678 18.5455 4.3678V6.30719ZM19.0304 15.2284C19.0304 15.5193 18.8365 15.7133 18.5455 15.7133V17.6526C19.9031 17.6526 20.9698 16.586 20.9698 15.2284H19.0304ZM3.0304 17.7011C3.0304 19.2042 4.67888 20.1254 5.98797 19.3496L4.96979 17.7011H3.0304ZM7.97585 15.8587L4.96979 17.7011L5.98797 19.3496L8.99403 17.5072L7.97585 15.8587ZM18.5455 15.7133H8.50918V17.6526H18.5455V15.7133ZM4.96979 17.7011V6.79204H3.0304V17.7011H4.96979ZM19.0304 6.79204V15.2284H20.9698V6.79204H19.0304ZM5.45464 6.30719H18.5455V4.3678H5.45464V6.30719ZM8.50918 16.683V15.7133H8.21827L7.97585 15.8587L8.50918 16.683Z"
        fill="white"
      />
    </g>
    <path
      d="M10.497 10.2829L7.58789 12.7072L8.21819 13.4344L11.1273 11.0102L10.497 10.2829ZM7.58789 8.63444L10.497 11.0587L11.1273 10.3314L8.21819 7.90717L7.58789 8.63444ZM10.7879 10.6708L11.0788 11.0587L11.5152 10.6708L11.0788 10.2829L10.7879 10.6708Z"
      fill="white"
    />
    <path d="M16.1212 12.1254H12.2424V13.0951H16.1212V12.1254Z" fill="white" />
  </svg>
);
export default SvgCodeInterview;
